// extracted by mini-css-extract-plugin
export var errorIcon = "_iu-1";
export var nameLogo = "_iu-0";